module.exports = __webpack_public_path__ + "img/edit.ef6950c2.svg";